import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faStar } from '@fortawesome/free-solid-svg-icons';
import Consultation from './consultation';
import { faSlack } from '@fortawesome/free-brands-svg-icons';

const PurchaseModal = ({ isOpen, onClose }) => {
  // 如果模态框未打开，则不渲染任何内容
  if (!isOpen) return null;

  // 定义选中的套餐
  const [consultationShow, setConsultationShow] = useState(false);

  // 处理订购按钮点击
  const handlePurchase = (plan) => {
    setConsultationShow(true)
  };

  return (
    // 背景遮罩层
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        {/* 模态框容器 */}
        <div className="bg-white rounded-xl shadow-2xl w-full max-w-[1200px] max-h-[90vh] overflow-hidden">
          {/* 模态框头部 */}
          <div className="px-8 py-6 relative" style={{ backgroundImage: 'url(/img/icon_1.png)', backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
            {/* 关闭按钮 */}
            <button 
              onClick={onClose}
              className="absolute top-4 right-4 text-white hover:text-white/80 transition-colors duration-200 z-10"
              aria-label="关闭模态框"
            >
              <FontAwesomeIcon icon={faTimes} size="lg" />
            </button>
            {/* 标题 */}
            <div className="text-center">
              <h2 className="font-bold text-white mb-2 flex items-center justify-center" style={{ fontSize: '40px' }}>
                <img src="/img/icon_3.png" style={{ width: '158px', height: '23px' }} className="mr-2" />
                云帐天下系统全新升级
                <img src="/img/icon_4.png" style={{ width: '158px', height: '23px' }} className="ml-2" />
              </h2>
              <p className="text-white/80">三大版本套餐正式上线</p>
            </div>
          </div>
          
          {/* 模态框内容 - 套餐卡片 */}
          <div className="p-6 overflow-y-auto max-h-[calc(90vh-100px)]">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {/* 基础版 */}
              <div 
                className="bg-white rounded-xl shadow-lg overflow-hidden border-gray-400 border-t-4 transition-transform duration-300 hover:scale-[1.02] hover:shadow-xl"
              >
                {/* 套餐头部 */}
                <div className="p-6">
                  {/* 套餐名称 */}
                  <h3 className="text-xl font-bold text-gray-800 mb-3">基础版</h3>
                  {/* 价格 */}
                  <div className="flex items-baseline mb-4 text-blue-600">
                    <span className="text-lg">¥</span>
                    <span className="text-4xl font-bold">2980</span>
                    <span className="text-lg ml-1">元</span>
                  </div>
                  {/* 订购按钮 */}
                  <button
                    onClick={() => handlePurchase()}
                    className="w-full py-3 font-semibold text-white bg-gray-500 hover:bg-gray-600 transition-all duration-300 transform hover:scale-[1.02] shadow-md hover:shadow-lg"
                    style={{ borderRadius: '21px' }}
                  >
                    立即订购
                  </button>
                </div>
                
                {/* 分隔线 */}
                <div className="border-t border-gray-100"></div>
                
                {/* 核心功能 */}
                <div className="p-6">
                  <h4 className="text-sm font-medium text-gray-500 mb-3" style={{ color: '#888' }}>核心包含功能:</h4>
                  <ul className="space-y-2">
                    <li key="feature-1" className="flex items-start text-sm">
                      <img src="/img/icon_5.png" className="mr-2 mt-0.5 w-4 h-4" />
                      <span className="text-gray-600">多平台数据同步</span>
                    </li>
                    <li key="feature-2" className="flex items-start text-sm">
                      <img src="/img/icon_5.png" className="mr-2 mt-0.5 w-4 h-4" />
                      <span className="text-gray-600">智能记账管理</span>
                    </li>
                    <li key="feature-3" className="flex items-start text-sm">
                      <img src="/img/icon_5.png" className="mr-2 mt-0.5 w-4 h-4" />
                      <span className="text-gray-600">全维度资金流水记录与查询</span>
                    </li>
                    <li key="feature-4" className="flex items-start text-sm">
                      <img src="/img/icon_5.png" className="mr-2 mt-0.5 w-4 h-4" />
                      <span className="text-gray-600">业务数据管理</span>
                    </li>
                    <li key="feature-5" className="flex items-start text-sm">
                      <img src="/img/icon_5.png" className="mr-2 mt-0.5 w-4 h-4" />
                      <span className="text-gray-600">客户数据管理</span>
                    </li>
                    <li key="feature-8" className="flex items-start text-sm">
                      <img src="/img/icon_5.png" className="mr-2 mt-0.5 w-4 h-4" />
                      <span className="text-gray-600">配套官方小程序端口</span>
                    </li>
                    <li key="feature-9" className="flex items-start text-sm">
                      <img src="/img/icon_5.png" className="mr-2 mt-0.5 w-4 h-4" />
                      <span className="text-gray-600">客户账单自动生成</span>
                    </li>
                  </ul>
                  
                  {/* 增值服务 */}
                  <div className="mt-4 pt-4 border-t border-gray-100">
                    <h4 className="text-sm font-medium text-gray-500 mb-2" style={{ color: '#888' }}>增值服务:</h4>
                    <ul className="space-y-1">
                      <li key="extra-1" className="text-sm text-gray-600">
                        报价维护，10元/个
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              
              {/* VIP标准版 */}
              <div 
                className="bg-white rounded-xl shadow-lg overflow-hidden border-orange-400 border-t-4 transition-transform duration-300 hover:scale-[1.02] hover:shadow-xl"
              >
                {/* 套餐头部 */}
                <div className="p-6">
                  {/* 套餐名称 */}
                  <h3 className="text-xl font-bold text-gray-800 mb-3">VIP标准版</h3>
                  {/* 价格 */}
                  <div className="flex items-baseline mb-4 text-orange-500">
                    <span className="text-lg">¥</span>
                    <span className="text-4xl font-bold">4980</span>
                    <span className="text-lg ml-1">元</span>
                  </div>
                  {/* 订购按钮 */}
                  <button
                    onClick={() => handlePurchase()}
                    className="w-full py-3 font-semibold text-white transition-all duration-300 transform hover:scale-[1.02] shadow-md hover:shadow-lg"
                    style={{ background: 'linear-gradient(90deg, #FF9900, #FFB658)', borderRadius: '21px' }}
                  >
                    立即订购
                  </button>
                </div>
                
                {/* 分隔线 */}
                <div className="border-t border-gray-100"></div>
                
                {/* 核心功能 */}
                <div className="p-6">
                  <h4 className="text-sm font-medium text-gray-500 mb-3" style={{ color: '#888' }}>核心包含功能:</h4>
                  <ul className="space-y-2">
                    <li key="feature-1" className="flex items-start text-sm">
                      <img src="/img/icon_5.png" className="mr-2 mt-0.5 w-4 h-4" />
                      <span className="text-gray-600">多平台数据同步</span>
                    </li>
                    <li key="feature-2" className="flex items-start text-sm">
                      <img src="/img/icon_5.png" className="mr-2 mt-0.5 w-4 h-4" />
                      <span className="text-gray-600">智能记账管理</span>
                    </li>
                    <li key="feature-3" className="flex items-start text-sm">
                      <img src="/img/icon_5.png" className="mr-2 mt-0.5 w-4 h-4" />
                      <span className="text-gray-600">全维度资金流水记录与查询</span>
                    </li>
                    <li key="feature-4" className="flex items-start text-sm">
                      <img src="/img/icon_5.png" className="mr-2 mt-0.5 w-4 h-4" />
                      <span className="text-gray-600">业务数据管理</span>
                    </li>
                    <li key="feature-5" className="flex items-start text-sm">
                      <img src="/img/icon_5.png" className="mr-2 mt-0.5 w-4 h-4" />
                      <span className="text-gray-600">客户数据管理</span>
                    </li>
                    <li key="feature-8" className="flex items-start text-sm">
                      <img src="/img/icon_5.png" className="mr-2 mt-0.5 w-4 h-4" />
                      <span className="text-gray-600">配套官方小程序端口</span>
                    </li>
                    <li key="feature-9" className="flex items-start text-sm">
                      <img src="/img/icon_5.png" className="mr-2 mt-0.5 w-4 h-4" />
                      <span className="text-gray-600">客户账单自动生成</span>
                    </li>
                    <li key="feature-6" className="flex items-start text-sm">
                      <img src="/img/icon_12.png" className="mr-2 mt-0.5 w-4 h-4" />
                      <span className="text-gray-600" style={{ color: '#FF9900' }}>员工数据管理</span>
                    </li>
                    <li key="feature-6" className="flex items-start text-sm">
                      <img src="/img/icon_12.png" className="mr-2 mt-0.5 w-4 h-4" />
                      <span className="text-gray-600" style={{ color: '#FF9900' }}>经营数据分析</span>
                    </li>
                    <li key="feature-10" className="flex items-start text-sm">
                      <img src="/img/icon_12.png" className="mr-2 mt-0.5 w-4 h-4" />
                      <span className="font-medium" style={{ color: '#FF9900' }}>网点数据分析</span>
                    </li>
                    <li key="feature-11" className="flex items-start text-sm">
                      <img src="/img/icon_12.png" className="mr-2 mt-0.5 w-4 h-4" />
                      <span className="font-medium" style={{ color: '#FF9900' }}>二级网点贡献报表</span>
                    </li>
                  </ul>
                  
                  {/* 专属权益 */}
                  <div className="mt-4 pt-4 border-t border-gray-100">
                    <h4 className="text-sm font-medium mb-2 flex items-center" style={{ color: '#D5A171' }}>
                      <img src="/img/icon_6.png" className="mr-2 mt-0.5 w-4 h-4" />
                      尊享专属权益
                    </h4>
                    <ul className="space-y-2">
                      <li key="right-1" className="text-sm text-gray-600">
                        赠送1个账套 + 1个子母管理账号
                      </li>
                      <li key="right-2" className="text-sm text-gray-600">
                        赠送20个报价维护名额，超出部分10元/个
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              
              {/* SVIP旗舰版 */}
              <div 
                className="bg-white rounded-xl shadow-lg overflow-hidden border-amber-400 border-t-4 transition-transform duration-300 hover:scale-[1.02] hover:shadow-xl"
              >
                {/* 套餐头部 */}
                <div className="p-6">
                  {/* 套餐名称 */}
                  <h3 className="text-xl font-bold text-gray-800 mb-3">SVIP旗舰版</h3>
                  {/* 价格 */}
                  <div className="flex items-baseline mb-4 text-amber-600">
                    <span className="text-lg">¥</span>
                    <span className="text-4xl font-bold">9980</span>
                    <span className="text-lg ml-1">元</span>
                  </div>
                  {/* 订购按钮 */}
                  <button
                    onClick={() => handlePurchase()}
                    className="w-full py-3 font-semibold text-white transition-all duration-300 transform hover:scale-[1.02] shadow-md hover:shadow-lg"
                    style={{ background: 'linear-gradient(90deg, #D5A171, #F0D4B8)', borderRadius: '21px' }}
                  >
                    立即订购
                  </button>
                </div>
                
                {/* 分隔线 */}
                <div className="border-t border-gray-100"></div>
                
                {/* 核心功能 */}
                <div className="p-6">
                  <h4 className="text-sm font-medium text-gray-500 mb-3" style={{ color: '#888' }}>核心包含功能:</h4>
                  <ul className="space-y-2">
                    <li key="feature-1" className="flex items-start text-sm">
                      <img src="/img/icon_5.png" className="mr-2 mt-0.5 w-4 h-4" />
                      <span className="text-gray-600">涵盖VIP标准版全部功能</span>
                    </li>
                  </ul>

                  {/* 专属权益 */}
                  <div className="mt-4 pt-4 border-t border-gray-100">
                    <h4 className="text-sm font-medium mb-2 flex items-center" style={{ color: '#D5A171' }}>
                      <img src="/img/icon_6.png" className="mr-2 mt-0.5 w-4 h-4" />
                      进阶新增专属模块
                    </h4>
                    <ul className="space-y-2">
                      <li key="feature-3" className="flex items-start text-sm">
                      <img src="/img/icon_5.png" className="mr-2 mt-0.5 w-4 h-4" />
                      <span className="text-gray-600">专业复式记账功能</span>
                    </li>
                    <li key="feature-5" className="flex items-start text-sm">
                      <img src="/img/icon_5.png" className="mr-2 mt-0.5 w-4 h-4" />
                      <span className="text-gray-600">车辆智能经营系统</span>
                    </li>
                    <li key="feature-6" className="flex items-start text-sm">
                      <img src="/img/icon_5.png" className="mr-2 mt-0.5 w-4 h-4" />
                      <span className="text-gray-600">AI智能经营参谋</span>
                    </li>
                    </ul>
                  </div>
                  
                  {/* 专属权益 */}
                  <div className="mt-4 pt-4 border-t border-gray-100">
                    <h4 className="text-sm font-medium mb-2 flex items-center" style={{ color: '#D5A171' }}>
                      <img src="/img/icon_6.png" className="mr-2 mt-0.5 w-4 h-4" />
                      尊享专属权益
                    </h4>
                    <ul className="space-y-2">
                      <li key="right-1" className="text-sm text-gray-600">
                        赠送4个账套 + 5个子母管理账号
                      </li>
                      <li key="right-2" className="text-sm text-gray-600">
                        赠送40个报价维护名额，超出部分10元/个
                      </li>
                    </ul>
                  </div>
                  
                  {/* 特殊权限 */}
                  <div className="mt-4 pt-4 border-t border-gray-100">
                    <div>
                      <h4 className="text-sm font-medium mb-2 flex items-center" style={{ color: '#D5A171' }}>
                        <img src="/img/icon_6.png" className="mr-2 mt-0.5 w-4 h-4" />
                        SVIP特殊权限
                      </h4>
                      <ul className="space-y-2">
                        <li key="special-1" className="text-xs text-gray-600 leading-relaxed">
                          1.首年专属福利：赠送4个二级系统名额
                          <p style={{ color: '#888' }}>仅限企业老板自有二级机构使用，超出4个部分按照1680元/个收取</p>
                        </li>
                        {/* <li key="special-2" className="text-xs text-gray-600 leading-relaxed">
                          2.次年二级系统优惠续费：仅需1680元/个
                          <p style={{ color: '#888' }}>原价2980元/个</p>
                          <p style={{ color: '#888' }}>注：关于以上三个定制化套餐增值部分： 账套超出部分，同平台二级 200元/个，一级500元/个。 员工账号超出部分200元/个</p>
                        </li> */}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Consultation
        isOpen={consultationShow}
        onClose={() => setConsultationShow(false)}
      />
    </>
  );
};

export default PurchaseModal;